<template>
  <transition name="fade">
    <img
      v-show="isLoaded"
      @load="onImageLoad()"
      id="picture-display"
      v-bind:src="url"
      v-bind:alt="title"
      style="height:inherit; width:inherit; object-fit:contain;"
    />
  </transition>
</template>
<script>
export default {
  name: "Thumbnail",
  props: ["url", "title"],
  watch: {
    url: function() {
      this.isLoaded = false;
    },
  },
  data() {
    return { isLoaded: false };
  },
  methods: {
    onImageLoad() {
      this.isLoaded = true;
    },
  },
};
</script>
<style>
.fade-enter-active {
  transition: opacity 0.4s ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}
</style>
